import {combineEpics, Epic} from 'redux-observable';
import {from, of} from 'rxjs';
import {
  switchMap,
  map,
  catchError,
  filter,
  tap
} from 'rxjs/operators';
import {isOfType} from 'typesafe-actions';
import {Intent, Position, Toaster} from "@blueprintjs/core";

import {
  S3ConnectionActions,
  S3ConnectionActionTypes,
  testS3ConnectionSuccess,
  testS3ConnectionFailure
} from '../actions/s3ConnectionActions';
import {IState} from '../reducers';
import {testS3Connection} from '../../services/s3ConnectionApi';

const s3ConnectionToaster = Toaster.create({
  className: 'recipe-toaster',
  position: Position.TOP
});


const testS3ConnectionEpic: Epic<S3ConnectionActions, S3ConnectionActions, IState> = (
  action$,
  state$
) =>
  action$.pipe(
    filter(isOfType(S3ConnectionActionTypes.TEST_S3_CONNECTION_REQUEST)),
    switchMap(action =>
      from(testS3Connection(action.payload.S3ConnectionSettings)).pipe(
        tap((response: any) => {
          const message = response.message || "Successfully connected to S3 bucket.";
          s3ConnectionToaster.show({
            message: message,
            intent: Intent.SUCCESS
          });
        }),
        map((response: any) => testS3ConnectionSuccess()),
        catchError((error) => {
          const message= error.response?.data?.message || "An error occurred while testing S3 connection.";

          s3ConnectionToaster.show({
            message: message,
            intent: Intent.DANGER
          });
          return of(testS3ConnectionFailure())
        })
      )
    )
  );

export default combineEpics(
  testS3ConnectionEpic
);
